module.exports = __webpack_public_path__ + "static/media/university-img-min.f8b56680.webp";